/*
 *
 * SummaryQuestions reducer
 *
 */

import { fromJS } from "immutable"
import {
  GET_LIST_COUNT_QUESTIONS_WATCHER,
  GET_LIST_COUNT_QUESTIONS_SUCCESS,
  GET_LIST_COUNT_QUESTIONS_FAILED,
} from "./constants"

export const initialState = fromJS({
  isLoading: true,
  questionTypes: {},
  totalQuestions: 0,
})

function widgetSummaryQuestionsReducer(state = initialState, action) {
  switch (action.type) {
    case GET_LIST_COUNT_QUESTIONS_WATCHER:
      return state.set("isLoading", true)

    case GET_LIST_COUNT_QUESTIONS_SUCCESS:
      return state
        .set("isLoading", false)
        .set("questionTypes", action.payload.questionTypes)
        .set("totalQuestions", action.payload.totalQuestions)

    case GET_LIST_COUNT_QUESTIONS_FAILED:
      return state
        .set("isLoading", false)
        .set("questionTypes", {})
        .set("totalQuestions", 0)

    default:
      return state
  }
}

export default widgetSummaryQuestionsReducer
